/* eslint-disable import/no-anonymous-default-export */
export default {
  sentry: {
    'dsn-missing': 'Sentry DNS Env variable is not define'
  },
  amplitude: {
    'key-missing': 'Amplitude key env variable is not define'
  },
}